import { produce } from 'immer';

import { createContext, useContext, useState } from 'react';
import { getInitialReadingLevel } from '../../../utils/users';
import languages from '../../../../public/json/languages.json';

// Common fields for all packets
const PacketBaseContext = createContext();
export const usePacketBase = () => useContext(PacketBaseContext);

export const PacketBaseProvider = ({ children }) => {
  const [language, setLanguageState] = useState(getInitialLanguage());
  const [readingLevel, setReadingLevelState] = useState(getInitialReadingLevel());
  const [languageStandards, _setLanguageStandards] = useState([]);
  const [contentStandard, _setContentStandard] = useState(null);
  const [orientation, _setOrientation] = useState(
    localStorage.getItem('packet-orientation') || '8.5x11'
  );
  const [templateId, _setTemplateId] = useState(null);

  const setTemplateId = (templateId) => {
    _setTemplateId((prev) => produce(prev, () => templateId));
    localStorage.setItem('packet-template-id', templateId);
  };

  const setOrientation = (orientation) => {
    _setOrientation((prev) => produce(prev, () => orientation));
    localStorage.setItem('packet-orientation', orientation);
  };

  const setLanguage = (language) => {
    setLanguageState((prev) => produce(prev, () => language));
    localStorage.setItem('packet-language-name', language.name);
  };

  const setReadingLevel = (readingLevel) => {
    setReadingLevelState((prev) => produce(prev, () => readingLevel));
    localStorage.setItem('packet-reading-level-id', readingLevel.id);
  };

  const setLanguageStandards = (languageStandards) => {
    _setLanguageStandards((prev) => produce(prev, () => languageStandards));
  };

  const setContentStandard = (contentStandards) => {
    _setContentStandard((prev) => produce(prev, () => contentStandards));
  };

  const removeLanguageStandard = (standard) => {
    _setLanguageStandards((prev) =>
      produce(prev, (draft) => {
        const index = draft.findIndex((s) => s.id === standard.id);
        if (index !== -1) {
          draft.splice(index, 1);
        }
      })
    );
  };

  const getBaseValues = () => {
    return {
      language,
      readingLevel,
      languageStandards,
      contentStandard,
      orientation,
      templateId,
    };
  };

  const value = {
    language,
    setLanguage,
    readingLevel,
    setReadingLevel,
    languageStandards,
    setLanguageStandards,
    contentStandard,
    setContentStandard,
    removeLanguageStandard,
    getBaseValues,
    orientation,
    setOrientation,
    templateId,
    setTemplateId,
  };

  return <PacketBaseContext.Provider value={value}>{children}</PacketBaseContext.Provider>;
};

const getInitialLanguage = (currentLanguage) => {
  const cachedLanguage = localStorage.getItem('packet-language-name');
  return languages.find((lang) => lang.name === (currentLanguage || cachedLanguage || 'English'));
};
